import { useEffect, useRef } from "react";

/** Push a history entry per drill-in level; browser/trackpad back pops the
 *  deepest open level instead of leaving the site. */
export function useBackNav(levels: { active: boolean; close: () => void }[]) {
  const ref = useRef(levels);
  ref.current = levels;
  const depth = levels.filter((l) => l.active).length;
  const prev = useRef(depth);
  useEffect(() => {
    if (depth > prev.current) window.history.pushState({ lt: depth }, "");
    prev.current = depth;
  }, [depth]);
  useEffect(() => {
    const h = () => {
      const ls = ref.current;
      for (let i = ls.length - 1; i >= 0; i--) {
        if (ls[i].active) { ls[i].close(); return; }
      }
    };
    window.addEventListener("popstate", h);
    return () => window.removeEventListener("popstate", h);
  }, []);
}

export const goBack = () => window.history.back();
